import React from 'react';
import { PackageIcon } from 'lucide-react';
import { motion, useReducedMotion } from 'framer-motion';
import { easeMove } from '../../utils/motion';
type PairingVisualProps = {
  active: number;
};
const brands = [{
  label: 'BRAND A',
  surface: 'bg-ink text-paper'
}, {
  label: 'BRAND B',
  surface: 'bg-water text-paper'
}];

/**
 * Two brand blocks converge into one shared product moment, then split back out
 * into separate readouts — the economics of sharing a moment, made spatial.
 */
export function PairingVisual({
  active
}: PairingVisualProps) {
  const reduceMotion = useReducedMotion();
  const converged = active >= 1;
  const delivered = active >= 2;
  const split = active >= 3;
  const transition = {
    duration: 0.3,
    ease: easeMove
  };
  return <div className="mx-auto w-full max-w-md" data-id="element-706" data-mp="xkorvyy1dmdc">
      <div className="relative h-[300px] border border-ink/20 bg-paper p-5" data-id="element-707" data-mp="xlqd2w8rnp8s">
        <div className="flex h-full flex-col justify-center gap-4" data-id="element-708" data-mp="12j9to2sxse3w">
          <div className="relative flex items-center justify-center gap-4" data-id="element-709" data-mp="2cd76r7v4xryn">
            {brands.map((brand, index) => <motion.div key={brand.label} animate={{
            x: reduceMotion ? 0 : converged ? 0 : index === 0 ? -28 : 28
          }} transition={transition} className={`flex h-20 flex-1 items-center justify-center text-xs font-extrabold tracking-[0.12em] ${brand.surface}`} data-id="element-710" data-mp="27db1746shsgz" data-mpi={index}>
                {brand.label}
              </motion.div>)}
          </div>

          <motion.div animate={{
          opacity: delivered ? 1 : 0.25
        }} transition={transition} className="flex items-center gap-4 border border-ink/20 bg-gold p-4" data-id="element-711" data-mp="22f9k2osxc385">
            <PackageIcon size={22} className="text-ink" aria-hidden="true" data-id="element-712" data-mp="19xx5hgyrca1v" />
            <div data-id="element-713" data-mp="1505huz55ba3h">
              <p className="text-xs font-extrabold tracking-[0.12em] text-ink/65" data-id="element-714" data-mp="150ngu3j702f3">
                ONE SHARED MOMENT
              </p>
              <p className="mt-1 text-sm font-extrabold text-ink" data-id="element-715" data-mp="351v7z0ivee5r">
                Produced, placed, and delivered once.
              </p>
            </div>
          </motion.div>

          <motion.div animate={{
          opacity: split ? 1 : 0
        }} transition={transition} className="grid grid-cols-2 gap-3" aria-hidden={!split} data-id="element-716" data-mp="3et9azia15w3n">
            {brands.map(brand => <div key={brand.label} className="border border-ink/20 p-3 text-center" data-id="element-717" data-mp="2r1u5jgmyiyo6">
                <p className="text-[10px] font-extrabold tracking-[0.12em] text-ink/55" data-id="element-718" data-mp="2w0nmxk5d79tm">
                  {brand.label}
                </p>
                <p className="mt-2 text-xs font-extrabold text-ink" data-id="element-719" data-mp="300pfn3t4gswr">
                  Own readout
                </p>
              </div>)}
          </motion.div>
        </div>
      </div>
      <p className="mt-5 text-center text-xs font-bold text-ink/55" data-id="element-720" data-mp="fenqfeuqt9di">
        ILLUSTRATIVE PAIRING STRUCTURE
      </p>
    </div>;
}